import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import MuiTextField from '@material-ui/core/TextField';

const styles = () => ({
    textField: {
        width: '100%'
    }
});

const TextField = ({
    id,
    name,
    value,
    setValue,
    placeholder,
    disabled,
    required,
    type,
    multiline,
    helperText,
    error,
    classes
}) => (
    <MuiTextField
        type={type}
        multiline={multiline}
        rows={4}
        rowsMax={8}
        id={id}
        label={name}
        onChange={({ target: { value: newValue } }) => setValue(newValue)}
        value={value}
        disabled={disabled}
        required={required}
        placeholder={placeholder}
        className={classes.textField}
        variant="outlined"
        inputProps={{
            id,
            name
        }}
        error={error}
        helperText={helperText}
    />
);

TextField.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    setValue: PropTypes.func,
    helperText: PropTypes.string,
    error: PropTypes.bool,
    type: PropTypes.string,
    multiline: PropTypes.bool
};

TextField.defaultProps = {
    disabled: false,
    required: false,
    type: 'text',
    multiline: false,
    placeholder: '',
    value: '',
    setValue: () => {},
    helperText: '',
    error: false
};

export default withStyles(styles)(TextField);
